import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';

export const navItems = [
  { key: 'home', icon: Images.home, title: 'Home', path: ROUTES.HOME },
  { key: 'history', icon: Images.request, title: 'Request', path: ROUTES.HISTORY },
  { key: 'message', icon: Images.messages, title: 'Message', path: ROUTES.MESSAGES },
  {
    key: 'settings',
    icon: Images.settings,
    title: 'Settings',
    path: ROUTES.SETTINGS,
  },
];
